<nav class="align-items-end desktop">
  <ul class="d-flex width-100">
    <ng-container>
      <li class="me-5" routerLink="price-list" routerLinkActive="active">{{'menus.home' | translate}}</li>
    </ng-container>

    <ng-container>
      <li class="me-5 d-flex {{isMenuActive('workspace') ? 'active' : ''}}" [matMenuTriggerFor]="workspace" (click)="expand('workspace')">
        {{'menus.workspace_settings' | translate}}
        <div class="icon-override red-icon arrow-{{expanded.workspace ? 'top' : 'down'}}-icon size-20" style="margin-left: 12px"></div>
      </li>
      <mat-menu class="py-3 px-2" #workspace="matMenu" [overlapTrigger]="false" (closed)="expand('workspace')">
        <ng-container>
          <button mat-menu-item [matMenuTriggerFor]="clients" class="{{isMenuActive('clients') ? 'active' : ''}}">{{'menus.clients' | translate}}</button>
          <mat-menu class="py-3 px-2" #clients="matMenu" [overlapTrigger]="false">
            <ng-container>
              <button mat-menu-item routerLink="workspace/clients">{{'menus.clients' | translate}}</button>
            </ng-container>
            <ng-container>
              <button mat-menu-item routerLink="workspace/clients/sold-to">{{'menus.sold_tos' | translate}}</button>
            </ng-container>
            <ng-container>
              <button mat-menu-item routerLink="workspace/clients/ship-to">{{'menus.ship_tos' | translate}}</button>
            </ng-container>
          </mat-menu>
        </ng-container>

        <ng-container>
          <button mat-menu-item routerLink="workspace/loading-site">{{'menus.loading_sites' | translate}}</button>
        </ng-container>
        <ng-container>
          <button mat-menu-item routerLink="workspace/contacts">{{'menus.contacts' | translate}}</button>
        </ng-container>

        <ng-container>
          <button mat-menu-item routerLink="workspace/product">{{'menus.products' | translate}}</button>
        </ng-container>
        
        <ng-container>
          <button mat-menu-item routerLink="workspace/users">{{'menus.users' | translate}}</button>
        </ng-container>

        <ng-container>
          <button mat-menu-item routerLink="workspace/currencies">{{'menus.currencies' | translate}}</button>
        </ng-container>

        <!-- <ng-container>
          <button mat-menu-item routerLink="workspace/sales-organisations">{{'menus.sales_organisations' | translate}}</button>
        </ng-container> -->

      </mat-menu>
    </ng-container>
    
    <ng-container>
      <li class="me-5 d-flex {{isMenuActive('indexes') ? 'active' : ''}}" [matMenuTriggerFor]="indexes" (click)="expand('indexes')">
        {{'menus.indexes' | translate}}
        <div class="icon-override red-icon arrow-{{expanded.indexes ? 'top' : 'down'}}-icon size-20" style="margin-left: 12px"></div>
      </li>
      <mat-menu class="py-3 px-2" #indexes="matMenu" [overlapTrigger]="false" (closed)="expand('indexes')">
        <ng-container>
          <button mat-menu-item routerLink="indexes/platts">{{'menus.platts' | translate}}</button>
        </ng-container>
      </mat-menu>
    </ng-container>
    @if(canViewAdminMenu()) {
        <ng-container>
        <li class="me-5 d-flex {{isMenuActive('administration') ? 'active' : ''}}" [matMenuTriggerFor]="menu" (click)="expand('administration')">
            {{'menus.administration' | translate}}
            <div class="icon-override red-icon arrow-{{expanded.administration ? 'top' : 'down'}}-icon size-20" style="margin-left: 12px"></div>
        </li>
        <mat-menu class="py-3 px-2" #menu="matMenu" [overlapTrigger]="false" (closed)="expand('administration')">
            <ng-container>
            <button mat-menu-item routerLink="administration/users">{{'menus.users' | translate}}</button>
            </ng-container>
            <ng-container>
            <button mat-menu-item routerLink="administration/workspaces">{{'menus.workspaces' | translate}}</button>
            </ng-container>
            <ng-container>
            <button mat-menu-item routerLink="administration/indexes">{{'menus.indexes' | translate}}</button>
            </ng-container>
            <ng-container>
            <button mat-menu-item routerLink="administration/sales-organisation">{{'menus.sales_organisations' | translate}}</button>
            </ng-container>
            <ng-container>
            <button mat-menu-item routerLink="administration/loading-site-ref">{{'menus.loading_site_ref' | translate}}</button>
            </ng-container>
            <ng-container>
            <button mat-menu-item routerLink="administration/currencies">{{'menus.currencies' | translate}}</button>
            </ng-container>
            <ng-container>
            <button mat-menu-item routerLink="administration/packagings">{{'menus.packagings' | translate}}</button>
            </ng-container>

            <ng-container>
            <button mat-menu-item routerLink="administration/testing">{{'menus.testing' | translate}}</button>
            </ng-container>

        </mat-menu>
        </ng-container>
    }
  </ul>
</nav>